import React, {useEffect, useState} from "react";
import axiosInstance from "../../api";
import {Box, Link, Paper, Snackbar, Typography} from "@material-ui/core";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import {Alert} from "@material-ui/lab";
import {Button} from "@mui/material";
import AgentSearchCriteriaCreateTile from "./AgentSearchCriteriaCreateTile";
import {Add, Delete, Edit, PlayArrow} from "@mui/icons-material";
import Spinner from "../../components/Spinner";
import {MUIConfirmationDialog} from "../../utils/formUtils";
import {useUserContext} from "../../context/UserContext";

export default function AgentSearchCriteriaListViewTile({agentId}) {
    // get the search criterial based on
    const [allSearchCriteria, setAllSearchCriteria] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showEditTile, setShowEditTile] = useState(false);
    const [critId, setCritId] = useState(null);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState(null);
    const [openSnackBarError, setOpenSnackBarError] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [deleteSearchId, setDeleteSearchId] = useState(null);
    const {user,dispatch} = useUserContext();

    useEffect(() => getAllSearchCriteria(), [agentId]);

    const getAllSearchCriteria = () => {
        setErrorMessage(null);
        setShowSpinner(true);
        axiosInstance.post('search/get-search-critieria', {agentId, status:'Active'})
            .then(data => {
                setErrorMessage(null);
                if (data && data.totalResultSetSize > 0) {
                    setAllSearchCriteria(data.resultList);
                } else {
                    setAllSearchCriteria([]);
                }

            }).catch(err => {
                setErrorMessage('An error occurred while retrieving the Search Criteria. Please try again later.');
        }).finally(() => setShowSpinner(false))
    };

    const showSearchCriteria = (searchId) => {
        setCritId(searchId);
        //setShowEditTile(true);
        setOpenEditDialog(true)
    };

    const addSearchCriteria = () => {
        setCritId(null);
        setShowEditTile(true);
    }

    const deleteCriteria =(searchId) => {
        setDeleteSearchId(searchId);
        setOpenDialog(true);
    }

    const runCriteria =(row,searchId) => {
        setShowSpinner(true);
        setErrorMessage(null);
        axiosInstance.post('agents/run-agent-search-critieria', {searchId: searchId})
            .then((data) => {
                setErrorMessage(null);
                setOpenSnackBarError(false);
                setOpenSnackBar(true);
                row.runExecuted=true;
                setSnackBarMessage(' New leads matching your criteria are in the Matching Leads section.');
            })
            .catch((error) => {
                setErrorMessage('An error occurred while matching records for your criteria. Please try again later.');
                setOpenSnackBarError(true);
                setOpenSnackBar(false);
                setSnackBarMessage('An error occurred while matching records for your criteria. Please try again later.');
            })
            .finally(() => setShowSpinner(false));
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
        setOpenSnackBarError(false);
    };

    const showMessageAfterReturnFromChild = (type, message) => {
        if (type === 'success') {
            setOpenSnackBarError(false);
            setOpenSnackBar(true);
            setSnackBarMessage(message);
        }

        if (type === 'error') {
            setOpenSnackBarError(true);
            setOpenSnackBar(false);
            setSnackBarMessage(message);
        }
    };

    function handleDClose() {
        setOpenDialog(false);
        setDeleteSearchId(null);
    }

    function handleEditClose() {
        setOpenEditDialog(false);
    }

    function handleDConfirm() {
        setShowSpinner(true);
        setErrorMessage(null);
        axiosInstance.delete('search/delete-agent-critieria/', {data:{searchId:deleteSearchId, agentId:agentId}})
            .then(() => {
                showMessageAfterReturnFromChild('success', 'Search Criteria deleted successfully!');
                getAllSearchCriteria();
                setDeleteSearchId(null);
                setOpenDialog(false);
            }).catch(() => {
            setDeleteSearchId(null);
            setOpenDialog(false);
            setOpenSnackBar(false);
            setOpenSnackBarError(true);
            setSnackBarMessage('An error occured while deleting a Criteria. Please try again later.');
        }).finally(() => setShowSpinner(false));
    }

    function handleEditConfirm() {
      setOpenEditDialog(false);
      setShowEditTile(true);
    }

    if (showSpinner) return <Spinner />
    return (
        <section>
            {!showEditTile && <Box m={2} marginBottom={0}>
                <Typography variant="h4" align="left" component="h4" gutterBottom
                            style={{paddingLeft: 6, fontWeight: 600}}>
                    Registered Search Criteria
                </Typography>
                {allSearchCriteria.length < 10 && user.locked === "N" && (user.fmapRole === "FMAP_ADMIN" || user.fmapRole === "FMAP_AGENT") && <Box component="span" justifyContent="flex-end" alignItems="flex-end"
                     display="flex">
                    <Button style={{marginBottom:3}} variant="outlined" onClick={addSearchCriteria} startIcon={<Add  />}>Add Search Criteria</Button>
                </Box>}

                {allSearchCriteria.length >= 10 && <Box component="span" display="flex" style={{backgroundColor: "lightblue", marginBottom:5}}  p={2}>
                    A maximum of 10 search criteria are allowed.
                </Box>}

                {allSearchCriteria.length >= 1 && <Box component="span" display="flex" style={{backgroundColor: "lightblue", marginBottom:5}}  p={2}>
                    Run button will only be enabled for new or edited search criteria.
                </Box>}


                <TableContainer>
                    <Table size="small" aria-label="a dense table">
                        <TableHead style={{backgroundColor: "#1c2438"}}>
                            <TableRow>
                                <TableCell style={{color: "#ffffff"}}>#</TableCell>
                                <TableCell  style={{color: "#ffffff"}}>Search Name</TableCell>
                                <TableCell style={{color: "#ffffff"}}>Status</TableCell>
                                <TableCell style={{color: "#ffffff"}}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allSearchCriteria?.map((row, index) => (
                                <TableRow
                                    key={row.searchId}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell component="th" scope="row">
                                        {index+1}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.searchName}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.status}
                                    </TableCell>
                                    <TableCell><Button size="small" startIcon={<Edit />} variant="outlined" style={{marginRight:3}}
                                        onClick={() => showSearchCriteria(row.searchId)}>Edit</Button>
                                        <Button  size="small" startIcon={<Delete />} variant="outlined" style={{marginRight:3}}
                                            onClick={() => deleteCriteria(row.searchId)}>Delete</Button>
                                        <Button  disabled={row.runExecuted} size="small" startIcon={<PlayArrow />} variant="outlined" style={{marginRight:3}}
                                            onClick={() => runCriteria(row,row.searchId)}>Run</Button></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {errorMessage && <Box>
                    <br/>
                    <Alert severity="error"  variant="filled">{errorMessage}</Alert>
                </Box>}
                <br/>
                <br/>
            </Box>}

            {showEditTile &&
                <Box>
                    <AgentSearchCriteriaCreateTile agenId={agentId} criteriaId={critId} setShowEditTile={setShowEditTile} getAllSearchCriteria={getAllSearchCriteria} showMessageAfterReturnFromChild={showMessageAfterReturnFromChild}/>
                </Box>
            }

            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert  variant="filled" onClose={handleSnackBarClose} severity="success">{snackBarMessage}</Alert>
            </Snackbar>

            <Snackbar open={openSnackBarError} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert  variant="filled" onClose={handleSnackBarClose} severity="error">{snackBarMessage}</Alert>
            </Snackbar>

            <MUIConfirmationDialog dialogTitle="Delete search criteria"
                                   //dialogContent="Are you sure you want to delete the criteria?"
                                   dialogContent="All leads associated with this search will be removed from the Matched Leads tab. Are you sure you want to delete this search?"
                                   showDialog={openDialog} handleDialogClose={handleDClose}
                                   handleUserConfirmation={handleDConfirm}></MUIConfirmationDialog>

            <MUIConfirmationDialog dialogTitle="Edit search criteria"
                                   dialogContent="All leads associated with the current search criteria will be removed from the Matched Leads tab. Are you sure you want to edit this search?"
                                   showDialog={openEditDialog} handleDialogClose={handleEditClose}
                                   handleUserConfirmation={handleEditConfirm}></MUIConfirmationDialog>

        </section>
    );
}
